import PoseInstructorContainer from './functionalities/PoseInstructorContainer';

function CreatePoseInstructor() {
  return <PoseInstructorContainer />;
}

export default CreatePoseInstructor;
